import { Injectable } from '@angular/core';
import { TranslationService } from '@layout/service/app.translation.service';
import { ListExternalApplicationsEnum } from '../models/enums/listExternalApplications.enum';

@Injectable({
  providedIn: 'root',
})
export class ExternalApplicationsUtils {
  constructor(private translationService: TranslationService) {}

  getDisplayValue(app: ListExternalApplicationsEnum): { name: string; description: string } {
    const name = this.translationService.getTranslation(`externalApplications.${app}.name`);
    const description = this.translationService.getTranslation(`externalApplications.${app}.description`);
    return {
      name: name || app, // Fallback to enum value if translation is missing
      description: description || '',
    };
  }
}